// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1Lpx7","footer":"ModalFilter_footer__2XhhV"};